export const VSTUP_BASE_API = 'vstup'
